document.addEventListener('DOMContentLoaded', () => {
  const loader = document.getElementById('booking-confirmation-loader');
  const checkmark = document.getElementById('booking-confirmation-check-mark');
  const billingSupport = document.getElementById('booking-confirmation-billing-support');
  const customerServiceCall = document.getElementById('booking-confirmation-customer-service-call');
  const shippingSupport = document.getElementById('booking-confirmation-shipping-support');
  const advancedTechnicalSupport = document.getElementById('booking-confirmation-advanced-technical-support');
  const generalSupport = document.getElementById('booking-confirmation-general-support');

  loader.style.display = 'none';
  checkmark.style.display = 'flex';

  const dateDisplay = document.querySelectorAll('.booking-confirmation-appointment-details ul li:nth-child(2) p');
  const timeDisplay = document.querySelectorAll('.booking-confirmation-appointment-details ul li:nth-child(3) p');

  const searchParams = new URLSearchParams(window.location.search);
  const serviceName = searchParams.get('service_name');
  const serviceDate = new Date(searchParams.get('booking_start_time'));

  const dateString = serviceDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

  const timeString = serviceDate.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Chicago'
  });

  dateDisplay.forEach(d => d.innerHTML = dateString)
  timeDisplay.forEach(t => t.innerHTML = timeString)

  switch (serviceName) {
    case 'Billing Support':
      billingSupport.style.display = 'flex'
      break;
    case 'Customer Service':
      customerServiceCall.style.display = 'flex'
      break;
    case 'Shipping and Receiving':
      shippingSupport.style.display = 'flex'
      break;
    case 'Technical Support':
      advancedTechnicalSupport.style.display = 'flex'
      break;
    default:
      generalSupport.style.display = 'flex';
      break;
  }
})
